<template>
    <button type="button" :class="cssClass" v-on:click="addSampleToCart">
        <slot></slot>
    </button>
</template>

<script>
    import ProductCardMixin from "../mixins/ProductCardMixin";

    export default {
        name: "OrderSampleButton",
        mixins: [ProductCardMixin],
        props: {
            cssClass: {
                type: String,
                required: false,
                default() {
                    return ''
                }
            }
        },
    }
</script>
